<div style="align-content: center" *ngIf="video" class="new-videos-carousel-item padded" (click)="openDetails(video.id,modalid)">  
    <img style="height: 140px;width:100%"src={{getThumbUrl(video.video_thumb)}}/> 
    <button type="button" class="btn btn-sm btn-gold float-start shadow">{{video.cat | uppercase}}</button>
    <div class="video-description">
      <p class="heading mb-0">{{video?.name | uppercase}} </p>
    </div>
  </div>  